import React from "react";
import PropTypes from "prop-types";
import StringField from "../../../common/form-field/StringField";

const number = value => (value && isNaN(Number(value)) ? "Must be a number" : undefined);

const NumberField = ({ validate, ...props }) => {
  return <StringField validate={[...validate, number]} {...props} />;
};

NumberField.propTypes = {
  validate: PropTypes.array.isRequired,
};

export default NumberField;



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/Number.js